import React,{ useState, useEffect } from "react";
import "../stories/familystories.css";
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import DependantStoryCard from './DependantStoryCard';
import swal from 'sweetalert';
import {Link} from 'react-router-dom'


const DependantStories =() => {

    const [peoplestories, setPeoplestories] = useState([]);

    useEffect(() => {
      var PeopleStories = Parse.Object.extend("PeopleStories");
      var query = new Parse.Query(PeopleStories);

      query.find()
      .then((stories) => {
        console.log(stories);
        setPeoplestories(stories.reverse());
      },(error) =>{
        console.log(error);
        swal("Oops!", "Seems like there is some problem with net...Please try again in sometime", "error");
      })
    }, []);

    return (
      <div>
        {/* <Header header=' Stories of Families' /> */}
        <Navbar head="Stories of Dependant" />
        <div style={{marginTop:"50px"}}>
          {/* Stories */}

        {
        peoplestories.map(story => (
          <DependantStoryCard  story={story.get("story")} shortstory={story.get("shortstory")} youtube={story.get("youtube")} link={story.id} />
        ))
      }

        <button className='story btn-primary btn-lg '><Link to="/peoplestories/addstory"><i className="fas fa-plus plus"></i>Add Your Story</Link></button>
        </div>

        
      </div>
    );
}

export default DependantStories;